/**
 * useStr — locale helpers for the landing + guide pages.
 *   const { t, ar, locale, arrow } = useStr();
 *   t('heroTitle')   → the string for the current locale (Arabic fallback)
 *   arrow            → the Hugeicons arrow pointing "forward" (left in RTL, right in LTR)
 */
import { ArrowLeft01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';
import { useLocale } from '../../lib/i18n';
import { STR, pick } from './strings.js';

export function useStr() {
  const locale = useLocale();
  const ar = locale === 'ar';
  const t = (key) => (STR[key] ? pick(STR[key], locale) : key);
  return { t, ar, locale, arrow: ar ? ArrowLeft01Icon : ArrowRight01Icon };
}

export default useStr;
